import React, { type PropsWithChildren } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Button, Modal, theme } from '@sg/garnish';

export const ScanAtCheckoutRewardOptionsModal = (props: ScanAtCheckoutRewardOptionsModalProps) => {
  const { children, isVisible, shouldShowCta, onPressButton, onRequestClose } = props;

  return (
    <Modal
      size="medium"
      palette="neutral"
      fitHeight
      visible={isVisible}
      onRequestClose={onRequestClose}
    >
      <SafeAreaView edges={['bottom']}>
        <Modal.CloseBtn palette="muted" onPress={onRequestClose} width={40} height={40} />

        {children}

        {shouldShowCta ? (
          <Modal.Footer withoutTopBorder style={styles.container}>
            <Button palette="primaryOutline" onPress={onPressButton} style={styles.cta}>
              <FormattedMessage {...messages.buttonText} />
            </Button>
          </Modal.Footer>
        ) : null}
      </SafeAreaView>
    </Modal>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  buttonText: {
    defaultMessage: 'Go to SG Rewards',
    description: 'Scan at checkout | Loyalty info | Button text',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  cta: {
    paddingHorizontal: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanAtCheckoutRewardOptionsModalProps = {
  children: PropsWithChildren['children'];
  isVisible: boolean;
  shouldShowCta: boolean;
  onPressButton: () => void;
  onRequestClose: () => void;
};
